import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import Page from '../components/Page';
import About from '../components/About';

const AboutTemplate = ({ data }) => (
  <Layout title="About | Highley-Varlet">
    <Page>
      <About content={data.allMarkdownRemark.edges[0].node} />
    </Page>
  </Layout>
);

export const query = graphql`
  query AboutTemplate {
    allMarkdownRemark(filter: { frontmatter: { template: { eq: "about" } } }) {
      edges {
        node {
          html
          frontmatter {
            title
          }
        }
      }
    }
  }
`;

export default AboutTemplate;
